var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainNavTracking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.09 9.3a.7.7 0 000 .99l2.77 2.77a.7.7 0 00.938.046l7.677-6.28-6.281 7.676a.7.7 0 00.046.938l2.77 2.77a.7.7 0 001.18-.347l4.9-12.719-.003-.001a.7.7 0 00-.93-.93l-.001-.003-12.73 4.904a.7.7 0 00-.336.186z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainNavTracking);
export default __webpack_public_path__ + "static/media/main-nav-tracking.dfe15a21a441aa5c6da12d3d78b6b6b2.svg";
export { ForwardRef as ReactComponent };